import _getters_links from './_getters/links.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    getters:{
        links: _getters_links,
    },
}